import React, { useEffect, useState } from 'react';
import { IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import Menu from '../components/Menu';
import ProtectedRoutes from '../components/ProtectedRoutes';
import Dashboard from '../pages/dashboard';
import { UNIFORM_RESOURCE_LOCATORS, PAGES_NOT_TO_SHOW_SPLIT_PANE } from '../utils/constants';
import { isLandlordLoggedIn } from '../utils/AuthUtils';
import Login from '../pages/Login';
import { Payments, Invoices, TenantTransactions } from '../pages/Financials';
import Tenants from '../pages/Tenants';
import Utilities from '../pages/Utilities';
import Properties from '../pages/Properties';
import Error404 from '../pages/404-Page/Index';
import generalSettings from '../pages/Settings/generalSettings';
import UserAccount from '../pages/Settings/userAccount';
import AlertSettings from '../pages/Settings/AlertSettings';
import Billing from '../pages/Account';
import subscriptionExpired from '../pages/SubscriptionExpired';
import Team from '../pages/Team';
import changePassword from '../pages/changePassword';
import newUserSurvey from '../pages/NewUserSurvey/newUserSurvey';
import StepwisePricing from '../pages/StepwisePricing';
import Reports from '../pages/Reports';
import BulkCreateInvoiceWizard from '../pages/Forms/BulkCreateInvoiceWizard/BulkCreateInvoiceWizard';

const IonSplitPlane = () => {
  const [showMenu, setShowMenu] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const shouldShowMenu = !PAGES_NOT_TO_SHOW_SPLIT_PANE.includes(location.pathname);
    setShowMenu(shouldShowMenu);
  }, [location]);

  if (!isLandlordLoggedIn()) {
    return <Redirect to={{ pathname: UNIFORM_RESOURCE_LOCATORS.appLogin, redirectTo: location.pathname }} />;
  }

  return (
    <IonSplitPane when={showMenu ? '' : false} contentId="main">
      <Menu />
      <IonRouterOutlet id="main">
        <Route path="/" exact={true}>
          <Redirect to={UNIFORM_RESOURCE_LOCATORS.dashboard} />
        </Route>

        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.dashboard} exact={true} component={Dashboard} />

        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.utilities} exact={true} component={Utilities} />

        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.payments} exact={true} component={Payments} />
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.invoices} exact={true} component={Invoices} />
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.bulkCreateInvoices} exact={true} component={BulkCreateInvoiceWizard} />
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.tenantTransactions} exact={true} component={TenantTransactions} />
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.reports} exact={true} component={Reports} />

        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.tenants} exact={true} component={Tenants} />
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.properties} tab="properties" exact={true} component={Properties} />
        <ProtectedRoutes key="units" path={UNIFORM_RESOURCE_LOCATORS.units} tab="units" properties exact component={Properties} />

        <Route path={UNIFORM_RESOURCE_LOCATORS.error404} exact={true} component={Error404}/>

        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.generalSettings} exact={true} component={generalSettings}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.alertSettings} exact={true} component={AlertSettings}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.accountInfo} exact={true} component={UserAccount}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.billing} exact={true} component={Billing}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.pricing} exact={true} component={StepwisePricing}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.team} exact={true} component={Team}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.changePassword} exact={true} component={changePassword}/>
        <ProtectedRoutes path={UNIFORM_RESOURCE_LOCATORS.survey} exact={true} component={newUserSurvey} />

        <Route path={UNIFORM_RESOURCE_LOCATORS.subscriptionExpired} exact={true} component={subscriptionExpired} />

        <Route path={UNIFORM_RESOURCE_LOCATORS.appLogin} exact={true}>
          <Login />
        </Route>

        <Redirect to={UNIFORM_RESOURCE_LOCATORS.error404} />

      </IonRouterOutlet>
    </IonSplitPane>
  );
};

export default IonSplitPlane;